export default function isConstituentId(value: string) {
  return /^cnx[A-Za-z0-9]{30}==$/.test(value);
}
